import urls from "../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../utils/service";

export async function AddLoanApi(body: any) {
    try {
      const callParams = await getCallParams("POST", body);
      const response = await makeCall(urls.ADDLOAN, callParams);
      return response;
    } catch (error) {
      throw error;
    }
  }